import useIntersection from 'hooks/useIntersection';
import React, { useRef } from 'react';
import styled from 'styled-components/macro';
import * as DEFAULTS from 'constants/defaults';

// Styles
const Img = styled.img<{ isInView: boolean }>`
    background: ${({ theme, isInView }) => !isInView && theme.background.skeleton};
`;

// Styles
interface ILazyImg {
  src: string,
  alt?: string,
  className?: string,
  decoding?: 'async' | 'auto' | 'sync' | undefined,
  onError?: (e?: any) => void,
}

// Component
const LazyImg = (props: ILazyImg) => {
  const {
    src,
    alt,
    className,
    decoding = 'async',
    onError,
  } = props;

  const imgRef = useRef<HTMLImageElement | null>(null);

  const {
    isHasView,
  } = useIntersection({
    ref: imgRef,
    once: true,
  });

  const emptyBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQA'
        + 'AAC1HAwCAAAAC0lEQVR42mP8Xw8AAoMBgDTD2qgAAAAASUVORK5CYII=';

  return (
    <Img
      ref={imgRef}
      src={isHasView ? src : emptyBase64}
      className={className}
      alt={alt}
      onError={onError}
      decoding={decoding}
      isInView={isHasView}
    />
  );
};

LazyImg.defaultProps = {
  alt: DEFAULTS.PROJECT_TITLE,
  className: '',
  decoding: 'async',
  onError: () => {},
};

export default LazyImg;
